<template>
  <path
    d="M20 18.0002V17.0002C21.1 17.0002 21.99 16.1002 21.99 15.0002L22 5.00018C22 3.90018 21.1 3.00018 20 3.00018H4C2.9 3.00018 2 3.90018 2 5.00018V15.0002C2 16.1002 2.9 17.0002 4 17.0002V18.0002H1C0.45 18.0002 0 18.4502 0 19.0002C0 19.5502 0.45 20.0002 1 20.0002H23C23.55 20.0002 24 19.5502 24 19.0002C24 18.4502 23.55 18.0002 23 18.0002H20ZM5 5.00018H19C19.55 5.00018 20 5.45018 20 6.00018V14.0002C20 14.5502 19.55 15.0002 19 15.0002H5C4.45 15.0002 4 14.5502 4 14.0002V6.00018C4 5.45018 4.45 5.00018 5 5.00018Z"
  />
</template>
